import { EAxiosResponseCode, getHttpErrorMessage, Http } from '@core/api';
import { getHostbaseUrl } from '@core/tools';
import { EProxyPayType, IIncomeTaxEditDetail, IIncomeTaxItem, IIncomeTaxParams } from '@core/main/types';

const hostUrl = getHostbaseUrl();

/**
 * 个税征收模板 - 分页
 */
export async function queryIncomeTaxPage(params: IIncomeTaxParams) {
  let data = [] as IIncomeTaxItem[];
  let total = 0;

  try {
    const { code, context, message } = await Http.post<{ data: IIncomeTaxItem[]; total: number }>(`${hostUrl}/side/server/rate/temp/page`, params);

    if (code === EAxiosResponseCode.Succeed) {
      const { data: items, total: all } = context || {} as { data: IIncomeTaxItem[]; total: number };

      data = items || [];
      total = all || 0;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    data,
    total, 
  };
}

/**
 * 个税征收模板 - 新增/编辑
 */
export async function updateIncomeTaxTemplate(params: IIncomeTaxEditDetail, type: 'add' | 'edit') {
  try {
    const { code, message } = await Http.post<void>(`${hostUrl}/side/server/rate/temp/${type}`, params);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 个税征收模板 - 详情
 */
export async function queryIncomeTaxTemplateDetail(id: number, proxyPayType?: EProxyPayType) {
  let data = {} as IIncomeTaxEditDetail;

  try {
    const { code, context, message } = await Http.post<IIncomeTaxEditDetail>(`${hostUrl}/side/server/rate/temp/detail`, {
      id,
      proxyPayType, 
    });

    if (code === EAxiosResponseCode.Succeed) {
      data = context || {} as IIncomeTaxEditDetail;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/**
 * 个税征收模板 - 列表
 */
export async function queryIncomeTaxTemplateList(proxyPayType?: EProxyPayType) {
  let data = [] as IIncomeTaxEditDetail[];

  try {
    const { code, context, message } = await Http.post<IIncomeTaxEditDetail[]>(`${hostUrl}/side/server/rate/temp/list`, { proxyPayType });

    if (code === EAxiosResponseCode.Succeed) {
      data = context || [] as IIncomeTaxEditDetail[];
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/**
 * 个税征收模板 - 删除
 */
export async function deleteIncomeTaxTemplate(id: number) {
  try {
    const { code, message } = await Http.post<void>(`${hostUrl}/side/server/rate/temp/delete`, { id });

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}
